import {
  Dumbbell,
  Target,
  Trophy,
  BarChart3,
  Medal,
  History,
  CalendarDays,
  Ruler,
  Video,
  Users,
  LucideIcon,
} from 'lucide-react';
import './FeaturesStrip.css';

interface FeatureItemData {
  Icon: LucideIcon;
  label: string;
}

const FEATURE_ITEMS: FeatureItemData[] = [
  { Icon: Dumbbell, label: 'Workout Logger' },
  { Icon: Target, label: 'Routine Builder' },
  { Icon: Trophy, label: 'Personal Records' },
  { Icon: BarChart3, label: 'Progress Charts' },
  { Icon: Medal, label: 'Strength Levels' },
  { Icon: History, label: 'Exercise History' },
  { Icon: CalendarDays, label: 'Monthly Reports' },
  { Icon: Ruler, label: 'Body Measurements' },
  { Icon: Video, label: 'Video Guides' },
  { Icon: Users, label: 'Social Feed' },
];

interface FeatureItemProps {
  Icon: LucideIcon;
  label: string;
}

function FeatureItem({ Icon, label }: FeatureItemProps) {
  return (
    <div className="feature-item">
      <Icon size={20} strokeWidth={1.5} className="feature-item-icon" />
      <span className="feature-item-label">{label}</span>
    </div>
  );
}

export function FeaturesStrip() {
  return (
    <section className="features-strip">
      <div className="features-marquee">
        {/* Render 4 copies to ensure seamless loop on all screen sizes */}
        {[...Array(4)].map((_, setIndex) => (
          <div className="features-container" key={setIndex}>
            {FEATURE_ITEMS.map((item) => (
              <FeatureItem key={item.label} Icon={item.Icon} label={item.label} />
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}

export default FeaturesStrip;


